import { render, staticRenderFns } from "./EnvironmentEdit.vue?vue&type=template&id=53284843&scoped=true&"
import script from "./EnvironmentEdit.vue?vue&type=script&lang=js&"
export * from "./EnvironmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentEdit.vue?vue&type=style&index=0&id=53284843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53284843",
  null
  
)

export default component.exports